import { Component, EventEmitter, Inject, OnInit, Output } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { SalesManagerModalService } from './sales-manager-modal.service';
import { BehaviorSubject, Subject } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import moment from 'moment';


export function followupTimeValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const selectedTime = control.value;

    if (!selectedTime) {
      return null;
    }

    const now = new Date();

    // Compare only hours and minutes
    const selectedMinutes =
      selectedTime.getHours() * 60 + selectedTime.getMinutes();

    const currentMinutes =
      now.getHours() * 60 + now.getMinutes();

    if (selectedMinutes > currentMinutes) {
      console.log('future time will not be allowed')
      return { futureTime: true };
    }

    return null;
  };
}
@Component({
  selector: 'app-sales-manager-modal',
  templateUrl: './sales-manager-modal.component.html',
  styleUrls: ['./sales-manager-modal.component.css']
})
export class SalesManagerModalComponent implements OnInit {
  @Output() successfulSubmission: EventEmitter<any> = new EventEmitter<any>();
  salesManagerForm!: FormGroup;
  submitted = false;
  formData: any;
  leadId: string | undefined; // Define leadId property
  leadstage: string | undefined;
  isLoading: Subject<boolean> = new Subject<boolean>();
  salesmanagers: any = [];
  masters: any = [];
  filteredProducts: any = [];
  filteredSalesmanagers: any = [];
  filteredRequirements: any = [];
  categories: any = [];
  products: any = [];
  productVariant: any = [];
  productColor: any = [];
  selectedProductId: any;
  filteredVariants: any[] = [];
  filteredColor: any[] =[];
  interestLevel: any[] = [];
  customerRequirements: any[] = [];
  ageGroupList: any = [];
  selectedAgeGroupID: any;
  selectedAgeGroup: any;
  selectedProductCategory: any;
  selectedProductCategoryID: any;
  selectedProductModel: any;
  selectedProductModelID: any;
  selectedProductVariant: any;
  selectedProductVariantID:any;
  selectedProductColor:any;
  selectedProductColorID:any;
  proudctCat: any = '';
  prod: any = '';
  prodVar = '';
  prodColor:any = '';
  ageGroup:any = '';
  selectedProductVariantCode:any ='';
  selectedProductModelCode:any ='';
  selectedProductColorCode:any = ''
  actionList:any = [];
  action:any = [];
  followupList:any = [];
  followup:any = '';
  followup_date:any = '';
  followup_time:any = '';
  minDate: any =new Date();
  constructor(
    public dialogRef: MatDialogRef<SalesManagerModalComponent>,
    private fb: FormBuilder,
    @Inject(MAT_DIALOG_DATA) public data: any, // Inject MAT_DIALOG_DATA
    private salesManagerModalService : SalesManagerModalService,
    private toastr: ToastrService
  ) {}

  ngOnInit(): void {
    const masters = JSON.parse(sessionStorage.getItem('masters') || '{}');

    if (masters) {
      this.masters = masters;
      this.salesmanagers = this.masters.salesManagers || [];
      this.categories = this.masters.productCategories || [];
      this.products = this.masters.productModel || [];      
      this.productVariant = this.masters.productVariant || [];
      this.productColor = this.masters.productColor || [];
      this.interestLevel = this.masters.interestLevel || [];
      this.customerRequirements = this.masters.customerRequirements || [];
      this.ageGroupList = this.masters.ageGroup || []
      this.actionList = this.masters.modeOfContact || [];
      this.followupList = this.masters.salesfollowUpReason || [];
    }
    // Initialize leadId from the passed data
    this.leadId = this.data.leadId;
    this.selectedProductCategory = this.data.selectedProductCategory;
    this.selectedProductCategoryID = this.data.selectedProductCategoryID;
    this.selectedProductModel = this.data.selectedProductModel;
    this.selectedProductModelID = this.data.selectedProductModelID;
    this.selectedProductModelCode = this.data?.selectedProductModelCode,
    this.selectedProductVariant = this.data.selectedProductVariant;
    this.selectedProductVariantID = this.data.selectedProductVariantID;
    this.selectedProductVariantCode = this.data?.selectedProductVariantCode,
    this.selectedProductColor = this.data.selectedProductColor;
    this.selectedProductColorID = this.data.selectedProductColorID;
    this.selectedProductColorCode= this.data?.selectedProductColorCode,

    this.selectedAgeGroupID = this.data.selectedAgeGroupID;
    this.selectedAgeGroup = this.data.selectedAgeGroup;

    if(this.data.selectedProductCategoryID){
      this.proudctCat = this.selectedProductCategoryID + ':' + this.selectedProductCategory 
      console.log(this.proudctCat);
      
    }
    if(this.data.selectedProductModelID){
      this.prod = this.selectedProductModelID + ':' + this.selectedProductModel + ' - ' + this.selectedProductModelCode

      console.log(this.prod);
      
    }
    if(this.data.selectedProductVariantID){
      this.prodVar = this.selectedProductVariantID + ':' + this.selectedProductVariant + ' - ' + this.selectedProductVariantCode
      console.log(this.prodVar);
      
    }
    if(this.data.selectedProductColorID){
      this.prodColor = this.selectedProductColorID + ':' + this.selectedProductColor + ' - ' + this.selectedProductColorCode

      console.log(this.prodColor);
      
    }

    if(this.data.selectedAgeGroupID){
      this.ageGroup = this.selectedAgeGroupID + ':' + this.selectedAgeGroup      
    }
   
    if(this.data.followup_date){
      this.followup_date = this.data.followup_date;    
    } else {
      // const d = new Date();
      // const today = String(d.getDate()).padStart(2, '0') + '/' + String(d.getMonth() + 1).padStart(2, '0') + '/' + d.getFullYear();
      
      // this.followup_date = today;   
      // this.followup_date = '';   
      // console.log(this.followup_date); 
    }
    
    if(this.data.followup){
      this.followup = this.data.followup;     
    }
    this.leadstage = this.data.leadStage

 

    this.salesManagerForm = this.fb.group({
      lead_id: [this.leadId],
      assign_to: ['', Validators.required],
      product_category: ['', Validators.required],
      product_model: ['', Validators.required],
      product_variant: [''],
      product_color: [''],
      interest_level: [''],
      customer_requirement: [''],
      remarks: [''],
      age_group: ['', Validators.required],
      followup_date: ['', Validators.required],
      // followup_time: ['', [Validators.required, followupTimeValidator()]],
      followup_time: ['', [Validators.required]],
      action: ['', Validators.required],
      followup: ['', Validators.required],
    });
    this.salesManagerForm.patchValue({age_group: this.ageGroup})
    this.salesManagerForm.patchValue({action: this.action})
    this.salesManagerForm.patchValue({followup_date: this.followup_date})
    this.salesManagerForm.patchValue({followup_time: this.followup_time})
    this.salesManagerForm.patchValue({followup: this.followup})
    this.filteredProducts = this.products.filter((product: any) => product.category_id === parseInt(this.selectedProductCategoryID));
    this.onCategoryChange({ target: { value: this.selectedProductCategoryID } });

    let productEvent = {
      target: {
        selectedOptions: [{ id: this.selectedProductModelID }],
        value: `${this.selectedProductModelID}:${this.selectedProductModel}`
      }
    };
  
    const selectedProductId = parseInt(this.selectedProductModelID);
    this.filteredVariants = this.productVariant.filter((variant: any) => variant.model_id == selectedProductId);
       
    const selectedVariant = this.filteredVariants.find((variant: any) => variant.id == this.selectedProductVariantID );  
     if (selectedVariant && selectedVariant?.color_id?.length > 0) {
      const colorIds = selectedVariant.color_id.map((id: any) => parseInt(id));
       this.filteredColor = this.productColor.filter((color: any) => colorIds.includes(color.id));
     } else {
       this.filteredColor = [];
     }
     setTimeout(()=>{
      this.salesManagerForm.patchValue({
        product_category:this.proudctCat ? this.proudctCat : '',
        product_model:this.prod ? this.prod : '',
        product_variant:this.prodVar ? this.prodVar : '',
        product_color: this.prodColor ? this.prodColor : ''
      });
     },100)
    
  }


  onNoClick(): void {
    this.dialogRef.close();
  }

  get f() {
    return  this.salesManagerForm.controls
  }

  onSubmit(): void {
    this.submitted = true
    if (!this.salesManagerForm.valid) {
      return
    }else {
      
      const productData: any = this.salesManagerForm.value;
      
      // followup: this.thirdFormGroup.value.followup,
      // action:this.thirdFormGroup.value.action,
      // next_followup_date: followupDate + ' ' + followupTime
      
      

      // productData.followup = this.salesManagerForm.get('followup_time')p,
      // productData.action =this.thirdFormGroup.value.action,


      // let followupDate: any = moment(this.salesManagerForm.get('followup_date')?.value,'DD-MM-YYYY').format('YYYY-MM-DD');
      let followupDate: any = moment(this.salesManagerForm.get('followup_date')?.value).format('YYYY-MM-DD');
      let followupTime = moment(this.salesManagerForm.get('followup_time')?.value, 'hh:mm A').format('HH:mm');
      productData.next_followup_date = followupDate + ' ' + followupTime
      
      console.log(productData);
      
      
      this.isLoading = new BehaviorSubject<boolean>(true);
			this.salesManagerModalService.createProduct(productData).subscribe((response: any) => {
				let responseData = response.body;
				if (responseData.responseCode == 200) {
          this.successfulSubmission.emit();
          this.dialogRef.close(this.formData);
          this.isLoading = new BehaviorSubject<boolean>(false);
					this.toastr.success("Lead assigned to DSE successfully!")
				} else {
          this.isLoading = new BehaviorSubject<boolean>(false);
					this.toastr.error(responseData.responseMessage)
				}
			}, (err: any) => {
				this.isLoading = new BehaviorSubject<boolean>(false);
        this.toastr.error("Please try again later!")
			});
		}
  }
  onCategoryChange(event: any) {
    const categoryId = event.target.value;
    if (categoryId) {
      this.filteredProducts = this.products.filter((product: any) => product.category_id === parseInt(categoryId));
      this.filteredSalesmanagers = this.salesmanagers.filter((catSales: any) => catSales.category_id === parseInt(categoryId));
      this.filteredColor = [];
      this.filteredVariants = [];
      console.log(this.filteredSalesmanagers);
      this.salesManagerForm.patchValue({
          product_model: '',
            product_variant: '',
            product_color: ''
      })
      
    } else {
      this.filteredProducts = [];
      this.filteredSalesmanagers = [];
    }
    this.submitted = false;
    } 

  //   onModelChange(event: any) {
  //     const target = event.target as HTMLSelectElement;
  //     const selectedOption = target.selectedOptions[0];
  //     this.selectedProductId = parseInt(selectedOption.id);
  //     const selectedProductId = parseInt(event.target.value);
  //     const selectedVariant = this.productVariant.find((variant: any) => variant.model_id === selectedProductId);
  //     this.filteredVariants = this.productVariant.filter((variant: any) => variant.model_id === selectedProductId);
  //         if (selectedVariant && selectedVariant.color_id) {
  //         this.filteredColor = this.productColor.filter((color: any) => selectedVariant.color_id.includes(color.id.toString()));
  //     } else {
  //         this.filteredColor = [];
  //     }
  //     console.log(this.filteredColor, 'filteredColor');
  // }
  onModelChange(event: any) {
    const target = event.target as HTMLSelectElement;
    const selectedOption = target.selectedOptions[0];
    this.selectedProductId = parseInt(selectedOption.id);
    const selectedProductId = parseInt(event.target.value);
    const selectedVariant = this.productVariant.find((variant: any) => variant.model_id === selectedProductId);  
    this.filteredVariants = this.productVariant.filter((variant: any) => variant.model_id === selectedProductId);
    
    // if (selectedVariant && selectedVariant.color_id && selectedVariant.color_id.length > 0) {
    //    // const colorIds = selectedVariant.color_id[0].split(',').map((id:any) => parseInt(id));
    //     const colorIds = selectedVariant.color_id.map((id:any) => parseInt(id));

    //     this.filteredColor = this.productColor.filter((color: any) => colorIds.includes(color.id));
    // } else {
    //     this.filteredColor = [];
    // }
  //   this.salesManagerForm.patchValue({
  //       product_variant:this.filteredVariants[0].id +":"+this.filteredVariants[0].variant,
  //       product_color: this.filteredColor[0].id +":"+this.filteredColor[0].color
  // })
  this.filteredColor = [];
  this.salesManagerForm.patchValue({
    product_variant:'',
    product_color: ''
})
    console.log(this.filteredColor, 'filteredColor');
}

  
    onVariantChange() {
      let variantId = this.salesManagerForm.value.product_variant?.split(":")[0]
      const selectedVariant = this.filteredVariants.find((variant: any) => variant.id == variantId );  
      console.log("selectedVariant: ", selectedVariant)
       if (selectedVariant && selectedVariant?.color_id?.length > 0) {
        const colorIds = selectedVariant.color_id.map((id: any) => parseInt(id));
         this.filteredColor = this.productColor.filter((color: any) => colorIds.includes(color.id));
       } else {
         this.filteredColor = [];
       }
      this.salesManagerForm.patchValue({
        product_color:''
      })
    }


    onInterestChange(event:any){
      const interestId = event.target.value;
      if (interestId) {
        this.filteredRequirements = this.customerRequirements.filter((product: any) => product.interest_level_id === parseInt(interestId));
      } else {
        this.filteredRequirements = [];
      }
    }
}